import React from "react";
import PropTypes from "prop-types";

import { get } from 'lodash';

const NavButton = ({ question= null, text = "", onClick = f => f, disabled = false, id = "" }) => {
    let buttonClasses = "w3-button w3-block w3-round-xxlarge w3-large w3-padding-large";
    buttonClasses += " " + get(question, "buttonColorClass", "w3-indigo");

    return (
        <button
            className={buttonClasses}
            id={id}
            type="button"
            disabled={disabled}
            onClick={() => onClick()}
        >
            {text}
        </button>
    );
};

NavButton.propTypes = {
    text: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    id: PropTypes.string
};

export default NavButton;
